import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter } from 'react-router-dom';
import { theme } from './theme';
// Self-hosted, so no font request ever leaves for a third party.
import '@fontsource-variable/bricolage-grotesque';
import '@fontsource-variable/hanken-grotesk';
import '@fontsource-variable/noto-sans-devanagari';
import App from './App';
import { setupPwa } from './lib/pwa';
import { setupViewportHeight } from './lib/viewport';
import { setupErrorReporting } from './lib/errors';
import { ErrorBoundary } from './components/ErrorBoundary';

setupPwa();
setupViewportHeight();
// Crashes and errors go to Twinden's own server, scrubbed (M67, D254).
setupErrorReporting();

const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element not found');
}

createRoot(root).render(
  <StrictMode>
    <ChakraProvider theme={theme}>
      <ErrorBoundary>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ErrorBoundary>
    </ChakraProvider>
  </StrictMode>
);
